import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const STATUSES = ["pending", "paid", "processing", "shipped", "out_for_delivery", "delivered", "cancelled", "refunded"];

export default function AdminOrders() {
    const [orders, setOrders] = useState([]);
    const [sel, setSel] = useState(null);
    const [status, setStatus] = useState("processing");
    const [trackingUrl, setTrackingUrl] = useState("");
    const [trackingNumber, setTrackingNumber] = useState("");

    const load = async () => setOrders((await api.get("/admin/orders")).data);
    useEffect(() => { load(); }, []);

    const openOrder = (o) => { setSel(o); setStatus(o.status); setTrackingUrl(o.tracking_url || ""); setTrackingNumber(o.tracking_number || ""); };
    const save = async () => {
        try {
            await api.put(`/admin/orders/${sel.id}/status`, { status, tracking_url: trackingUrl || null, tracking_number: trackingNumber || null });
            toast.success("Updated"); setSel(null); load();
        } catch { toast.error("Failed"); }
    };

    return (
        <div data-testid="admin-orders">
            <h1 className="font-display text-4xl tracking-tighter mb-6">Orders</h1>
            <div className="bg-white border-2 border-black overflow-auto">
                <table className="w-full text-sm">
                    <thead className="border-b-2 border-black"><tr className="font-mono text-[10px] uppercase text-left">
                        <th className="p-3">Order #</th><th className="p-3">Customer</th><th className="p-3">Total</th><th className="p-3">Payment</th><th className="p-3">Status</th><th className="p-3">Qikink</th><th className="p-3">Date</th>
                    </tr></thead>
                    <tbody>
                        {orders.map(o => (
                            <tr key={o.id} onClick={() => openOrder(o)} className="border-b border-neutral-200 cursor-pointer hover:bg-neutral-50" data-testid={`admin-order-${o.order_number}`}>
                                <td className="p-3 font-mono">{o.order_number}</td>
                                <td className="p-3">{o.address.full_name}<br/><span className="font-mono text-[10px] text-neutral-500">{o.email}</span></td>
                                <td className="p-3 font-mono">₹{Math.round(o.total)}</td>
                                <td className="p-3 font-mono text-xs uppercase">{o.payment_method}</td>
                                <td className="p-3 font-mono text-xs uppercase text-[hsl(var(--accent))]">{o.status}</td>
                                <td className="p-3 font-mono text-[10px] uppercase">{o.qikink_status?.status || "—"}</td>
                                <td className="p-3 font-mono text-xs">{new Date(o.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                        {orders.length === 0 && <tr><td colSpan={7} className="p-8 text-center font-mono text-xs">No orders yet.</td></tr>}
                    </tbody>
                </table>
            </div>

            <Dialog open={!!sel} onOpenChange={(v) => !v && setSel(null)}>
                <DialogContent className="border-2 border-black max-w-2xl max-h-[85vh] overflow-y-auto">
                    {sel && (
                        <>
                            <DialogHeader><DialogTitle className="font-display text-2xl">Order #{sel.order_number}</DialogTitle></DialogHeader>
                            <div className="grid grid-cols-2 gap-4 font-mono text-xs">
                                <div><div className="uppercase text-neutral-500">Customer</div><div>{sel.address.full_name}</div><div>{sel.email}</div><div>{sel.address.phone}</div></div>
                                <div><div className="uppercase text-neutral-500">Address</div><div>{sel.address.line1}</div><div>{sel.address.city}, {sel.address.state} {sel.address.pincode}</div></div>
                                <div><div className="uppercase text-neutral-500">Payment</div><div>{sel.payment_method}</div><div>{sel.payment_status}</div></div>
                                <div><div className="uppercase text-neutral-500">Qikink</div><div>{sel.qikink_status?.status || "—"}</div><div className="text-neutral-500">{sel.qikink_status?.reason || ""}</div></div>
                            </div>
                            <div className="border-t-2 border-black pt-3 mt-3">
                                <div className="font-mono text-[10px] uppercase mb-2">Items</div>
                                {sel.items.map((it, i) => <div key={i} className="flex justify-between font-mono text-xs"><span>{it.name} × {it.quantity} ({it.size})</span><span>₹{Math.round(it.price * it.quantity)}</span></div>)}
                                <div className="flex justify-between font-display text-xl mt-2"><span>Total</span><span>₹{Math.round(sel.total)}</span></div>
                            </div>
                            <div className="border-t-2 border-black pt-4 space-y-3">
                                <label className="block">
                                    <div className="font-mono text-[10px] uppercase mb-1">Update Status</div>
                                    <select value={status} onChange={e => setStatus(e.target.value)} className="w-full border-2 border-black p-2 font-mono text-sm" data-testid="order-status-select">
                                        {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </label>
                                <input placeholder="Tracking URL" value={trackingUrl} onChange={e => setTrackingUrl(e.target.value)} className="w-full border-2 border-black p-2 font-mono text-sm" />
                                <input placeholder="Tracking Number" value={trackingNumber} onChange={e => setTrackingNumber(e.target.value)} className="w-full border-2 border-black p-2 font-mono text-sm" />
                            </div>
                            <DialogFooter><button onClick={save} className="bg-black text-white px-4 py-2 font-mono text-xs uppercase" data-testid="save-order-btn">Save</button></DialogFooter>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}
